<tec-modal
    [isVisible]="isVisible"
    [title]="'CONNECTIONS.TYPES.' + connectionType?.toUpperCase() | translate"
    (closeEvent)="closeModal()">
    <ng-container body>
        @switch (connectionType) {
            @case (CONNECTION_TYPE.BANK_SCORING) {
                <p>{{ 'CONNECTIONS.BANK_SCORING.SUBTITLE' | translate }}</p>
                <div style="width: 544px; align-self: center">
                    <pwcs-inline-svg
                        [src]="'assets/images/instructions-bankscoring.svg'"
                        idSuffix="modal-instructions-bankscoring"
                    />
                </div>
            }
            @case (CONNECTION_TYPE.IRPF) {
                <p>{{ 'CONNECTIONS.IRPF.SUBTITLE' | translate }}</p>
                <img
                    [src]="'assets/images/instructions-irpf.png'"
                    [alt]="'DOCUMENTS.ACCESSIBILITY.INSTRUCTIONS_PHOTO' | translate"
                    loading="lazy"
                    style="width: 544px; align-self: center;"
                />
            }
            @case (CONNECTION_TYPE.WORK_LIFE) {
                <p>{{ 'CONNECTIONS.WORK_LIFE.SUBTITLE' | translate }}</p>
                <img
                    [src]="'assets/images/instructions-worklife.png'"
                    [alt]="'DOCUMENTS.ACCESSIBILITY.INSTRUCTIONS_PHOTO' | translate"
                    loading="lazy"
                    style="width: 544px; align-self: center;"
                />
            }
            @case (CONNECTION_TYPE.SCRIPTURE) {
                <p [innerHTML]="'CONNECTIONS.SCRIPTURE.SUBTITLE' | translate"></p>
                <img
                    [src]="'assets/images/instructions-escrituras.png'"
                    [alt]="'DOCUMENTS.ACCESSIBILITY.INSTRUCTIONS_PHOTO' | translate"
                    loading="lazy"
                    style="width: 544px; align-self: center;"
                />
            }
        }
    </ng-container>
</tec-modal>